import React, { useEffect, useRef, useContext } from "react";
import { UserContext } from "../UserContext";
import { FaTimes, FaQrcode, FaWallet, FaRupeeSign, FaCopy, FaShare } from "react-icons/fa";
import "./index.css";

const QRCodeModal = ({ onClose, upiId = "your-upi@bank" }) => {
  const { token, user } = useContext(UserContext);
  const modalRef = useRef(null);

  // Handle escape key press
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) onClose();
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  // Handle copy UPI ID
  const handleCopyUPI = () => {
    navigator.clipboard.writeText(upiId)
      .then(() => {
        // You could add a toast notification here
        alert("UPI ID copied to clipboard!");
      })
      .catch(err => {
        console.error("Failed to copy UPI ID: ", err);
      });
  };

  // Handle share functionality
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Payment Details',
          text: `Please find the payment QR code for UPI payment. UPI ID: ${upiId}`,
          url: window.location.href,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    } else {
      // Fallback: copy to clipboard
      handleCopyUPI();
    }
  };

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div 
        className="qr-modal" 
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        role="dialog"
        aria-labelledby="qr-modal-title"
        aria-modal="true"
      >
        {/* Header */}
        <div className="qr-modal-header">
          <div className="qr-title">
            <FaWallet className="title-icon" aria-hidden="true" />
            <h2 id="qr-modal-title">Wallet</h2>
          </div>
          <button 
            className="qr-close-btn" 
            onClick={onClose}
            aria-label="Close modal"
          >
            <FaTimes aria-hidden="true" />
          </button>
        </div>

        {/* Payment Methods */}
        <div className="payment-methods">
          <h3 className="section-title">
            <FaQrcode className="section-icon" aria-hidden="true" />
            Scan & Pay
          </h3>

          {/* QR Code */}
          <div className="qr-code-continer">
            
            {(user?.ottplayOperCode === 17297 && user?.watchoOperCode === 10972315 ) ? (
              <img 
                src="https://vrplay.in/images/masterqr.jpg" 
                alt="UPI QR Code for payment"
                className="qr-code-image"
                loading="lazy"
              />
            ) : (user?.createdBy === 1 || user?.createdBy === "1") ? (
              <>
                <img 
                  src="https://vrplay.in/images/sdtechqr.jpeg" 
                  alt="UPI QR Code for payment"
                  className="qr-code-image"
                  loading="lazy"
                />
              </>
            ) : ("")}
          </div>
          
          <p className="instruction-text">
            Use any UPI app to scan the QR code & send money
          </p>
          
          {/* Additional Info */}
          <div className="additional-info">
          <p className="info-text simple-pulse">
            After payment, please share the receipt with admin.
          </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;